import { render, staticRenderFns } from "./virtual_warehouses.vue?vue&type=template&id=5f10597e"
import script from "./virtual_warehouses.vue?vue&type=script&lang=js"
export * from "./virtual_warehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports